import { motion } from "framer-motion";
import { Wifi, Battery, Signal } from "lucide-react";

export default function HeroPhone() {
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.2, 0.7, 0.2, 1] }}
            className="relative mx-auto w-[260px] sm:w-[300px]"
        >
            <motion.div
                animate={{ y: [-8, 8] }}
                transition={{ duration: 5, repeat: Infinity, repeatType: "reverse", ease: "easeInOut" }}
                className="phone-frame"
            >
                <div className="phone-screen">
                    <div className="absolute top-0 left-0 right-0 z-20 px-5 pt-3 flex items-center justify-between text-white/90 text-[11px] font-semibold">
                        <span>9:41</span>
                        <div className="flex items-center gap-1">
                            <Signal className="w-3.5 h-3.5" />
                            <Wifi className="w-3.5 h-3.5" />
                            <Battery className="w-4 h-4" />
                        </div>
                    </div>
                    <div className="absolute top-2 left-1/2 -translate-x-1/2 z-30 h-5 w-24 rounded-full bg-black" />
                    <img
                        alt="Phone screen"
                        src="https://images.unsplash.com/photo-1510557880182-3d4d3cba35a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=600"
                        className="h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-slate-900/40" />
                    <div className="absolute bottom-6 left-5 right-5 z-20">
                        <div className="glass rounded-2xl p-3 border-white/30">
                            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-700">Activated · AT&T</div>
                            <div className="font-display text-base font-bold text-slate-900 mt-0.5">iPhone 15 Pro</div>
                            <div className="text-[11px] text-slate-600">Ready to go in 5 minutes</div>
                        </div>
                    </div>
                </div>
            </motion.div>

            {/* Floating accent cards */}
            <motion.div
                animate={{ y: [6, -6] }}
                transition={{ duration: 4.5, repeat: Infinity, repeatType: "reverse", ease: "easeInOut" }}
                className="absolute -left-12 top-10 hidden sm:block glass rounded-2xl px-3 py-2.5 premium-shadow"
            >
                <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">5G Coverage</div>
                <div className="font-display font-bold text-slate-900">Nationwide</div>
            </motion.div>
            <motion.div
                animate={{ y: [-6, 6] }}
                transition={{ duration: 4, repeat: Infinity, repeatType: "reverse", ease: "easeInOut", delay: 0.6 }}
                className="absolute -right-10 bottom-20 hidden sm:block glass rounded-2xl px-3 py-2.5 premium-shadow"
            >
                <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">Trade-in</div>
                <div className="font-display font-bold text-slate-900">+ $200</div>
            </motion.div>
        </motion.div>
    );
}
